import { cn } from "@gettactic/helpers";

export const MeetingUserGrid = ({
  children,
  classNames
}: {
  children: React.ReactNode;
  classNames?: string;
}) => {
  return (
    <div
      className={cn(
        "flex flex-col md:grid w-full grid-cols-3 gap-2",
        classNames
      )}
    >
      {children}
    </div>
  );
};
